import { render, staticRenderFns } from "./CleaningAreasMetrics.vue?vue&type=template&id=91d0a28e&scoped=true"
import script from "./CleaningAreasMetrics.vue?vue&type=script&lang=js"
export * from "./CleaningAreasMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d0a28e",
  null
  
)

export default component.exports